
export const generalInfo = {
  typeDescriptions: {
    cardToExample: 'Matcha kortet med rätt exempel',
    exampleToCard: 'Matcha exemplet med rätt kort',
    titleToDescription: 'Matcha begreppet med rätt beskrivning',
    descriptionToTitle: 'Matcha beskrivningen med rätt begrepp',
    titleToExample: 'Matcha begreppet med rätt exempel',
  },
}


export const easyQuiz = {
  questionTypes: [
    'cardToExample',
    'exampleToCard',
  ],
  questionCategories: [0, 2],
  totalQuestions: 5,
}
export const hardQuiz = {
  questionTypes: [
    'cardToExample',
    'exampleToCard',
    'titleToDescription',
    'descriptionToTitle',
    'titleToExample'
  ],
  minQuestionsOfType: [
    {type: 'cardToExample', count: 3}
  ],
  totalQuestions: 5,
}

export const quizes = {
  "easy": easyQuiz,
  "hard": hardQuiz
}
